/**
 * Site Configuration for Handover Period
 * 
 * This configuration file controls temporary restrictions during the platform handover.
 * Set these flags to true to pause/disable features, or false to restore normal operation.
 * 
 * IMPORTANT: After the handover is complete, set all flags to false to restore normal functionality.
 */

const siteConfig = {
  // ============================================
  // HANDOVER SETTINGS - Set to true during handover period
  // ============================================
  
  /**
   * When true, displays the handover information banner at the top of the website
   */
  showHandoverBanner: true,

  /**
   * When true, pauses new user registrations for youth/interns
   * Users will see a message explaining the temporary pause
   */
  pauseYouthRegistration: true,

  /**
   * When true, pauses new user registrations for businesses/organisations
   * Businesses will see a message explaining the temporary pause
   */
  pauseBusinessRegistration: true,

  /**
   * When true, pauses the ability to post new job opportunities
   * Existing opportunities remain visible
   */
  pauseOpportunityPosting: true,

  // ============================================
  // BANNER CONFIGURATION
  // ============================================
  
  /**
   * The banner message displayed to users (fallback - translations are in locale files)
   * Key: 'handoverBannerText' in translation files
   */
  bannerTextFallback: `Please note that this website will close on 31 August 2026. Thank you for following cesty.space and being part of the CESTY community. You can continue following new opportunities, events and resources for young people on the CESTY Instagram and Telegram channels.`,

  /**
   * Contact email for opt-out requests and inquiries
   */
  contactEmail: 'info@cesty.space',
};

export default siteConfig;

